<script setup lang="ts">
import Button from '~/components/design-system/button.vue';
import { ChevronLeftIcon } from '@heroicons/vue/24/outline';

interface IGenericPageHeaderProps {
  returnRoute?: string;
}
defineProps<IGenericPageHeaderProps>();

const router = useRouter();
</script>

<template>
  <div class="generic-page-header py-0 z-5">
    <div
      class="w-full bg-primary-layer rounded-2xl flex items-center gap-2 p-2 font-bold"
      style="z-index: 4"
    >
      <Button
        v-if="!!returnRoute"
        type="tertiary"
        size="icon-lg"
        @click="router.push(returnRoute)"
      >
        <ChevronLeftIcon />
      </Button>
      <slot />
    </div>
  </div>
</template>

<style scoped lang="scss">
.generic-page-header {
  top: 90px;
  position: sticky;
  @media screen and (min-width: 1536px) {
    top: 116px;
  }
  @media screen and (min-width: 768px) and (max-width: 1535px) {
    top: 100px;
  }
  .container {
    @media screen and (max-width: 640px) {
      border-radius: 0;
    }
  }
}
</style>
